document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener("change", function(e) {
    if (!e.target.matches(".select-option-choose")) return;

    const select = e.target;
    const selected = e.target.options[e.target.selectedIndex];
    const price = selected.dataset.price / 100;
    const cprice = selected.dataset.cprice / 100;
    const selectedId = select.value;
    const moneyFormat = window.format;
    const priceBox = select.closest(".product-card-wrapper");

      if (priceBox) {
        priceBox.querySelector(".reg_price").innerHTML = moneyFormat.replace('{{amount}}', price);
        if(cprice > price){
          priceBox.querySelector(".compare_price").innerHTML = moneyFormat.replace('{{amount}}', cprice);
        }else{
          if(priceBox.querySelector(".compare_price")){
            priceBox.querySelector(".compare_price").innerHTML = '';
          }
        }
      }  
      priceBox.querySelector('[name="id"]').value = selectedId;
      
  });
});